import {
    getInsuranceFromSails,
    getSessionStorageItemJson,
} from '@vfde-sails/storage';
import {
    SAILS_BNT_STORAGE,
    SAILS_PARAM_INSURANCE,
} from '@vfde-sails/constants';
import {
    APP,
    CONTAINER_TARIFF,
} from '../../../app/constants';
import { SailsDeviceDetailsStorage } from '../../../interfaces/storage';

/**
 * Get insurance from session storage
 */
export const getInsurance = (): string | null => {
    const storage = getSessionStorageItemJson<SailsDeviceDetailsStorage | null>(SAILS_BNT_STORAGE);

    if (!storage) {
        return null;
    }

    return getInsuranceFromSails(storage)
        ?? storage?.[APP]?.[CONTAINER_TARIFF]?.[SAILS_PARAM_INSURANCE]
        ?? null;
};
